import React from 'react';
import SVGIcon from 'react-md/lib/SVGIcons/SVGIcon';
import './icon.module.scss';

const Stop = props => (
  <SVGIcon {...props} role="presentation" viewBox="0 0 116.91 116.9">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <polygon
          fill="#ffffff"
          points="82.67 0 34.24 0 0 34.24 0 82.66 34.24 116.9 82.67 116.9 116.91 82.66 116.91 34.24 82.67 0"
        />
        <path
          fill="#000000"
          d="M45.41,93.25V83.9c0-5-7.45-10.46-7.45-16.74V50.58a3.27,3.27,0,0,1,6.54,0v8.87a1,1,0,1,0,2.07,0V29.53a3.27,3.27,0,0,1,6.53,0V51.25a1,1,0,0,0,2.08,0v-3.8h0V26.91a3.27,3.27,0,0,1,6.53,0V51.24a1,1,0,1,0,2.08,0V47.45h0V30.18a3.26,3.26,0,0,1,6.52,0V51.24a1,1,0,0,0,2.08,0V47.45h0V37.8a3.27,3.27,0,0,1,6.53,0V72.24c0,4.71-4.93,10.29-4.93,14v7Z"
        />
      </g>
    </g>
  </SVGIcon>
);

export default Stop;
